
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(378|756|864)$/.test(chunkId);
},
rootOutputDir: "../../",

    };
}
